module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-4.183feacf.jpg";